import PageBanner from "app/components/ui/PageBanner"
import HelmetTitle from "app/meta/HelmetTitle"
import React from 'react'
import './styles/ServicesPage.css'
import sectionImg1 from 'app/assets/images/general-medicine-1.jpg'
import sectionImg2 from 'app/assets/images/general-medicine-2.jpg'
import sectionImg3 from 'app/assets/images/general-medicine-3.jpg'
import PageSection from "app/components/ui/PageSection"
import AppButton from "app/components/ui/AppButton"
import MakeAppointment from "app/components/homepage/MakeAppointment"

export default function GeneralMedicinePage() {
  return (
    <div className="general-medicine-page services-page">
      <HelmetTitle title="General Medicine" />
      <PageBanner
        title="General Medicine"
        subtitle="Promoting wellness and improving quality of life through personalized care."
      />
      <div className="page-content">
        <PageSection
          subtitle="What is General Medicine?"
          title="Understanding the Different Specialties of General Medicine"
          text={<p>
            General Medicine encompasses a wide range of medical specialties, each
            focusing on specific organs or systems of the body. Some of the common
            specialties within General Medicine include cardiology, gastroenterology,
            endocrinology, pulmonology, nephrology, neurology, and rheumatology, among
            others.
            <br /><br />
            Cardiologists specialize in diagnosing and treating heart and
            cardiovascular system diseases, while gastroenterologists focus on the
            digestive system and liver diseases. Endocrinologists specialize in
            hormone-related disorders, and pulmonologists treat lung and respiratory
            system diseases.
          </p>}
          img={sectionImg1}
          btn={
            <AppButton
              label="Learn More"
              buttonType="secondaryBtn"
            />
          }
        />
        <PageSection
          direction="rtl"
          subtitle="Choosing a Family Physician"
          title="The Benefits of General Medicine"
          text={<p>
            Choosing a family physician is an important decision, and the benefits
            of General Medicine can make it easier. General Medicine doctors, also
            known as family physicians, are trained to provide comprehensive care to
            patients of all ages, from newborns to the elderly. They serve as primary
            healthcare providers, offering a wide range of medical services, from
            preventive care and health screenings to managing chronic diseases and
            acute illnesses.
            <br /><br />
            The personalized care provided by family physicians
            ensures that patients receive the attention and care they need to stay
            healthy and improve their quality of life. Moreover, as family physicians
            are familiar with their patients' medical histories and lifestyles, they
            can provide individualized and continuous care that takes into account
            their patients' unique health needs and concerns.
          </p>}
          img={sectionImg2}
          btn={
            <AppButton
              label="Learn More"
              buttonType="secondaryBtn"
            />
          }
        />
        <PageSection
          subtitle="A Healthier you"
          title="Promoting Wellness Through Personalized Care"
          text={<><p>
            General Medicine is an all-encompassing field of medicine that
            focuses on promoting wellness for individuals of all ages. General
            Medicine practitioners are equipped to provide comprehensive care
            to their patients, from infants to seniors, and to address a wide
            range of medical concerns.
          </p>
            <ul>
              <li>Comprehensive care for patients of all ages</li>
              <li>Skilled in preventive care to maintain optimal health</li>
              <li>Manage chronic diseases for longer, healthier lives</li>
              <li>Treatment for acute illnesses to avoid complications</li>
              <li>Holistic approach to medicine for improved wellness</li>
            </ul>
          </>}
          img={sectionImg3}
          btn={
            <AppButton
              label="Learn More"
              buttonType="secondaryBtn shadowHover"
            />
          }
        />
        <MakeAppointment />
      </div>
    </div>
  )
}
